import { format } from "date-fns";
import { de, enUS } from "date-fns/locale";

export const formatDateShort = (dateString: string) => {
  if (!dateString) return "";
  try {
    const date = new Date(dateString);
    // Format as DD/MM/YY
    return `${date.getDate().toString().padStart(2, "0")}/${(
      date.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}/${date.getFullYear().toString().substring(2)}`;
  } catch (_error) {
    return dateString;
  }
};

export const formatDateLong = (dateString: string, language: string = "en") => {
  if (!dateString) return "";
  try {
    const date = new Date(dateString);
    const locale = language === "de" ? de : enUS;
    return format(date, "dd. MMMM yyyy", { locale });
  } catch {
    return dateString;
  }
};
